import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'kt-vehicletype',
  templateUrl: './vehicletype.component.html',
  styleUrls: ['./vehicletype.component.scss']
})
export class VehicletypeComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
